// Imports


// Project imports
import Search from '@js/modules/Search.js';


class Page {
    constructor() {
        this.init();
    }
    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.domLoaded();
        });

        window.addEventListener('load', () => {
            this.windowLoaded();
        });
    }
    loadAll() {
        this.domLoaded();
        this.windowLoaded();
    }
    domLoaded() {

        // Search form
        const searchForm = document.getElementById('search-form');
        if (searchForm) {
            new Search(searchForm);
        }

    }

    windowLoaded() {

    }
}

export default new Page();

